<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M11.842,19.499c-4.333,0-8.636-3.04-11.219-5.884c-0.831-0.923-0.831-2.312-0.002-3.232
		c2.584-2.845,6.892-5.883,11.234-5.883c0.051,0,0.1,0,0.151,0.001c0.042-0.001,0.097-0.001,0.153-0.001
		c4.328,0,8.634,3.038,11.219,5.881c0.831,0.923,0.832,2.312,0.002,3.233c-2.586,2.846-6.897,5.886-11.245,5.886
		c0,0-0.149-0.001-0.149-0.001L11.842,19.499L11.842,19.499z M11.853,5.999c-3.851,0-7.753,2.784-10.12,5.39
		c-0.312,0.346-0.312,0.871,0.002,1.22c2.366,2.605,6.267,5.39,10.12,5.39l0.131-0.001l0.136,0.001
		c3.867,0,7.776-2.785,10.145-5.392c0.312-0.346,0.312-0.871-0.002-1.22c-2.368-2.604-6.272-5.387-10.123-5.387
		c0,0-0.154,0.001-0.156,0.001L11.853,5.999z"/>
	<path d="M11.998,16.498c-1.202,0-2.332-0.469-3.182-1.319c-0.85-0.85-1.318-1.98-1.317-3.182c0-2.481,2.019-4.499,4.5-4.499
		c1.202,0,2.332,0.468,3.182,1.317c0.85,0.85,1.318,1.979,1.318,3.181c0,1.206-0.469,2.335-1.319,3.185
		c-0.85,0.849-1.979,1.317-3.181,1.317H11.998z M12,8.998c-1.654,0-3,1.345-3,2.999c0,0.801,0.312,1.555,0.878,2.121
		c0.567,0.567,1.32,0.879,2.121,0.879c0.802,0,1.555-0.312,2.121-0.878s0.879-1.32,0.879-2.121c0-0.804-0.312-1.557-0.879-2.123
		C13.554,9.31,12.801,8.998,12,8.998L12,8.998z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'view-1',
    },
    name: {
      type: String,
      required: false,
      default: 'View1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>